// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"Jurisprudence_searchForm__2KWog","searchFieldsRow":"Jurisprudence_searchFieldsRow__1r8cF","actionsRow":"Jurisprudence_actionsRow__2djGF"};